<dx-toolbar class="yo-toolbar">
  <dxi-item location="before">
    <div class="d-flex flex-row align-items-center">
      <yo-help class="mg-r-15" lang="fr" [file]="pathFile" [dialogMsgSupplier]="help()" [width]="800"></yo-help>
      <yo-button
        class="mg-r-15"
        label="CRÉER"
        iconClass="fa fa-plus"
        [theme]="ButtonThemeEnum.ADD"
        tooltip="Création d'un marché"
        (onClick)="openEditObject(undefined)"
        [disabled]="!canCreate()">
      </yo-button>
    </div>
  </dxi-item>
</dx-toolbar>
<dx-data-grid
  [dataSource]="marcheList"
  keyExpr="id"
  [height]="utils.getWindowAvailableHeight(182)"
  width="100%"
  [hoverStateEnabled]="true"
  [rowAlternationEnabled]="true"
  [allowColumnResizing]="true"
  [showRowLines]="true"
  [showBorders]="true"
  #grid>
  <dxi-column dataField="id" caption="Actions" [width]="100"
              [allowFiltering]="false"
              [allowGrouping]="false"
              cellTemplate="actionsCellTemplate">
  </dxi-column>
  <dxi-column dataField="libelle" caption="Marché" [width]="350"
              [allowFiltering]="true" cellTemplate="libelleCellTemplate">
  </dxi-column>

  <dxi-column dataField="site" caption="Site" [width]="200" cellTemplate="siteCellTemplate"
              [allowFiltering]="true">
  </dxi-column>
  <dxi-column dataField="code" caption="Code" [width]="150" [allowFiltering]="true">
  </dxi-column>
  <dxi-column dataField="descriptif" caption="Description"
              [width]="350"
              [allowFiltering]="true">
  </dxi-column>
  <dxi-column dataField="dateDebut" caption="Date de début" [width]="150" dataType="date"
              [allowFiltering]="true">
  </dxi-column>
  <dxi-column dataField="dateFin" caption="Date de fin" [width]="150" dataType="date"
              [allowFiltering]="true">
  </dxi-column>
  <dxi-column dataField="actif" caption="Actif" [width]="80"
              [allowFiltering]="true">
  </dxi-column>

  <!--  ACTIONS CELL TEMPLATE-->
  <div *dxTemplate="let cell of 'siteCellTemplate'">
    <yo-site [siteId]="cell.row.data.site.id" [siteLibelle]="cell.row.data.site.libelle"></yo-site>
  </div>

  <div *dxTemplate="let cell of 'actionsCellTemplate'" class="custom-button-container">
    <yo-button size="small"
                    [theme]="ButtonThemeEnum.DEFAULT_INNER" (onClick)="openEditObject(cell.row.data)"
                    [iconClass]="canModify(cell.row.data) ? 'fa fa-edit' : 'fa fa-eye'"
                    [tooltip]="(canModify(cell.row.data) ? 'Modifier' : 'Voir') + ' le marché'"
    ></yo-button>
    <yo-button size="small"
                    [theme]="ButtonThemeEnum.DELETE_INNER" *ngIf="canModify(cell.row.data)"
                    (onClick)="openDeleteObject(cell.row.data)"
                    iconClass="fa fa-trash"
                    tooltip="Supprimer le marché"
    ></yo-button>
  </div>

  <div *dxTemplate="let cell of 'libelleCellTemplate'">
    {{cell.row.data?.libelle | uppercase}}
    <div>
      <yo-gef-audit-button
        [gefAuditList]="this.gefSvc.retrieveGefAuditListByIdEntity(gefAuditList, cell.row.data.id)">
      </yo-gef-audit-button>
    </div>
  </div>

  <dxo-pager
    [showPageSizeSelector]="false"
    [showNavigationButtons]="false"
    [visible]="true"
    [showInfo]="true"
    infoText="{2} marchés">
  </dxo-pager>



</dx-data-grid>

<yo-dialog-gef-audit></yo-dialog-gef-audit>




